export default __webpack_public_path__ + "static/media/informationtohelp.a00c2d1f.svg";